import { lazy } from 'react';
import AppQr from './AppQr';


// PAN Verification
const AutoFetchPanScreen = lazy(() => import('src/screens/PanVerification/AutoFetchPanScreen'));
const UserPanInputScreen = lazy(() => import('src/screens/PanVerification/UserPanInputScreen'));
const UserNameAutoFetchScreen = lazy(() => import('src/screens/PanVerification/UserNameAutoFetchScreen'));
const UserNameInputScreen = lazy(() => import('src/screens/PanVerification/UserNameInputScreen'));
const UserNameMismatchScreen = lazy(() => import('src/screens/PanVerification/UserNameMismatchScreen'));
const PanNumberConfirmationScreen = lazy(() => import('src/screens/PanVerification/PanNumberConfirmationScreen'));

// Basic Details
const DOBScreen = lazy(() => import('src/screens/BasicDetails/DOBScreen'));
const SelectOccupationScreen = lazy(() => import('src/screens/BasicDetails/SelectOccupationScreen'));
const GenderSelectionScreen = lazy(() => import('src/screens/BasicDetails/GenderSelectionScreen'));
const FathersNameScreen = lazy(() => import('src/screens/BasicDetails/FathersNameScreen'));
const IncomeRangeScreen = lazy(() => import('src/screens/BasicDetails/IncomeRangeScreen'));
const MaritalStatusScreen = lazy(() => import('src/screens/BasicDetails/MaritalStatusScreen'));
const TradingExperienceScreen = lazy(() => import('src/screens/BasicDetails/TradingExperienceScreen'));
const CoparcenerDetailScreen = lazy(() => import('src/screens/BasicDetails/CoparcenerDetail'));
const KycDeclaration = lazy(() => import('src/screens/BasicDetails/KycDeclaration'));

// Bank Verification
const AutoFetchBank = lazy(() => import('src/screens/BankVerification/AutoFetchBank'));
const BankRPDScreen = lazy(() => import('src/screens/BankVerification/BankRPDScreen'));
const BankPDScreen = lazy(() => import('src/screens/BankVerification/BankPDScreen'));

// Document Upload
const Digilocker = lazy(() => import('src/screens/Digilocker'));
const DocumentUploadScreen = lazy(() => import('src/screens/ManualDocUpload/AddressUpload/DocumentUploadScreen'));
const ManualDocUpload = lazy(() => import('src/screens/ManualDocUpload'));
const AddressTextScreen = lazy(() => import('src/screens/ManualDocUpload/AddressUpload/AddressText'));

// Contact Update
const EmailUpdate = lazy(() => import('src/screens/EmailUpdate'));
const MobileUpdate = lazy(() => import('src/screens/MobileUpdate'));
const OtpVerificationScreen = lazy(() => import('src/screens/OtpVerificationScreen'));

// Verification
const EkycVerification = lazy(() => import('src/screens/EkycVerification'));
const LocationFetchScreen = lazy(() => import('src/screens/DetectLocation'));

// Proof of Ownership
const IncomeProofScreen = lazy(() => import('src/screens/IncomeProof'));
const NomineeInfo = lazy(() => import('src/screens/NomineeInfo'));
const NomineeOtpVerificationScreen = lazy(() =>
  import('src/screens/NomineeInfo/NomineeOtpVerificationScreen')
);
const SelfieScreen = lazy(() => import('src/screens/SelfieScreen'));
const SignatureUpload = lazy(() => import('src/screens/SignatureUpload'));

// E-sign & FnO
const AOFEsign = lazy(() => import('src/screens/AOFEsign'));
const FnoConfirmationScreen = lazy(() => import('src/screens/FnoConfirmationScreen'));

// State Screens
const ErrorScreen = lazy(() => import('src/screens/StateScreens/ErrorScreen'));
const PendingScreen = lazy(() => import('src/screens/StateScreens/PendingScreen'));
const SuccessScreen = lazy(() => import('src/screens/StateScreens/SuccessScreen'));

export {
  AutoFetchPanScreen,
  UserPanInputScreen,
  UserNameAutoFetchScreen,
  UserNameInputScreen,
  UserNameMismatchScreen,
  PanNumberConfirmationScreen,
  DOBScreen,
  SelectOccupationScreen,
  GenderSelectionScreen,
  FathersNameScreen,
  IncomeRangeScreen, 
  MaritalStatusScreen,
  TradingExperienceScreen,
  CoparcenerDetailScreen,
  KycDeclaration,
  BankPDScreen,
  BankRPDScreen,
  AutoFetchBank,
  DocumentUploadScreen,
  ManualDocUpload,
  AddressTextScreen,
  EmailUpdate,
  MobileUpdate,
  OtpVerificationScreen,
  EkycVerification,
  LocationFetchScreen,
  AOFEsign,
  FnoConfirmationScreen,
  Digilocker,
  IncomeProofScreen,
  NomineeInfo,
  NomineeOtpVerificationScreen,
  SelfieScreen,
  SignatureUpload,
  ErrorScreen,
  PendingScreen,
  SuccessScreen,
  AppQr
}
